export default "skymp5-front/4240b22a3e4ea3d863083d8cc66dc9d2.svg";